import React, { Component } from "react";
import Search from "./Search";
import { connect } from "react-redux";
import { changeCatalogMode } from "modules/Catalog/actions";

class Toolbar extends Component {
  generateItemRange = () => {
    const { currentPage, pageLength, arrayLength } = this.props;
    let minimum = currentPage * pageLength - pageLength + 1;

    if (minimum > arrayLength) {
      minimum = 1;
    }

    let maximum = currentPage * pageLength;

    if (maximum > arrayLength) {
      maximum = arrayLength;
    }

    return `${minimum} - ${maximum}`;
  };

  handleChangeModeClick = event => {
    let { mode } = event.currentTarget.dataset || event.srcElement.dataset;
    this.props.changeCatalogMode(mode === "list");
  };

  render() {
    const range = this.generateItemRange();

    const {
      arrayLength,
      handleSearchClick,
      handleSearchTyping,
      isListMode
    } = this.props;

    const { handleChangeModeClick } = this;

    return (
      <div className="toolbar">
        <div>
          Showing <strong>{range}</strong> of <strong>{arrayLength}</strong>{" "}
          items
        </div>

        <Search
          handleSearchTyping={handleSearchTyping}
          handleSearchClick={handleSearchClick}
        />

        <div className="toolbar__mode">
          <button
            onClick={handleChangeModeClick}
            data-mode="grid"
            className={!isListMode ? "button button--secondary" : "button"}
          >
            <i className="fas fa-th-large" />
          </button>
          <button
            onClick={handleChangeModeClick}
            data-mode="list"
            className={isListMode ? "button button--secondary" : "button"}
          >
            <i className="fas fa-th-list" />
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { isListMode } = state.catalogReducer;

  return {
    isListMode: isListMode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    changeCatalogMode: isListMode => dispatch(changeCatalogMode(isListMode))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);



// WEBPACK FOOTER //
// ./src/modules/Catalog/components/Toolbar.jsx